import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader } from "reactstrap";

const ViewModal = ({
  show,
  setShow,
  modalBody,
  title,
  disableOutsideClick = false,
  size = "xl",
}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  return (
    // {/********************* MODAL *****************/}
    <Modal
      size={size}
      isOpen={show}
      className={isRTL ? "rtl-modal" : ""}
      toggle={() => {
        if (!disableOutsideClick) {          
          setShow(false);
        }
      }}
    >
      {/********************* MODAL HEADER *****************/}
       <ModalHeader tag="div" toggle={() => setShow(false)} className="align-items-center">
                  <h5 className="modal-title fw-semibold mb-0">{(t(title))}</h5>
       </ModalHeader>

      {/* ********************* MODAL BODY ***************** */}
      <div className="modal-body">{modalBody}</div>
    </Modal>
  );
};

ViewModal.propTypes = {
  setShow: PropTypes.func,
  show: PropTypes.bool,
};

export default ViewModal;
